module.exports = __webpack_public_path__ + "img/hover-iocn0.6b490e12.svg";